export const PACKAGE_TRANSFER = {
  order_package_id: '',
  internal_order: '',
  cage_name: '',
  door_name: '',
}

export const INITIAL_SHIPPING_SEARCH_PARAMS = {
  id: '',
  client_id: '',
  order_number: '',
  order_package_status_id: '',
  sort_method: 'desc',
  order_by: 'id',
  limit: 15,
  page: 1,
}

export const SHIP_INITIAL_STATE = {
  carrier_id: '',
  location_name: '',
  tracking_number: '',
  trackings: [],
  locations: [],
  door_name: '',
}

export const REMOVE_TYPE = {
  LOCATION: 'location',
  TRACKING: 'tracking',
}

export const ADD_TYPE = {
  LOCATION: 'location',
  TRACKING: 'tracking',
}
